import { useEffect } from 'react'
import { useMutation, useApolloClient, gql } from '@apollo/client'
import { useLocation } from 'react-router-dom'

import { resolvers as urlsResolvers } from 'resolvers/urls'

const SET_LAST_URL = gql`
  mutation SetLastUrl($url: String!) {
    setLastUrl(url: $url) @client
  }
`

export const withLastUrl =
  (Component: TSFixMe): TSFixMe =>
  (props: TSFixMe): TSFixMe => {
    const client = useApolloClient()
    client.addResolvers(urlsResolvers)
    const location = useLocation()

    const [setLastUrl] = useMutation(SET_LAST_URL)

    useEffect((): TSFixMe => {
      setLastUrl({
        variables: {
          url: `${location.pathname}${location.search}`
        }
      })
    }, [])

    return <Component {...props} />
  }
